import { render } from "./toggleSwitch.vue?vue&type=template&id=77d71188&scoped=true"
import script from "./toggleSwitch.vue?vue&type=script&lang=js"
export * from "./toggleSwitch.vue?vue&type=script&lang=js"

import "./toggleSwitch.vue?vue&type=style&index=0&id=77d71188&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d71188"]])

export default __exports__